import Loading from '../../../Common/Loading';
import { useMappingChartsDataContext } from './hooks/useMappingChartsDataContext';
import { EvolutionTeam } from './EvolutionTeam';
import { TableEvolutionTeam } from './TableEvolutionTeam';

export const Charts = () => {
    const { isLoading } = useMappingChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <EvolutionTeam />
                <TableEvolutionTeam />
            </div>
        </>
    );
};
